import { render, staticRenderFns } from "./UserWechat.vue?vue&type=template&id=15d76b35&scoped=true&"
import script from "./UserWechat.vue?vue&type=script&lang=js&"
export * from "./UserWechat.vue?vue&type=script&lang=js&"
import style0 from "./UserWechat.vue?vue&type=style&index=0&id=15d76b35&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d76b35",
  null
  
)

export default component.exports